import { Button } from './ui/button';
import useAuth from '../hooks/useAuth'
import { Pencil } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import EditProfileModal from './EditProfileModal';


function General() {
  const { user } = useAuth();
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
        <section>
            <h2 className='text-lg font-semibold !mb-8'>
              Personal Information
            </h2>
            <div>
                {user?.image ? (
                    <div className='flex items-end gap-3 mb-4'>
                        <img
                            src={user?.image}
                            alt="User Profile"
                            className="size-[50px] border rounded p-1"
                        />
                        <Button variant="ghost" className='pb-0' onClick={() => setOpenModal(true)}>
                            <Pencil />
                        </Button>
                    </div>
                ) : (
                    <div className='flex items-end gap-1 mb-4'>
                        <div className="size-[50px] rounded bg-gray-600 flex items-center justify-center text-white text-xs">            
                            {`${user?.name?.charAt(0).toUpperCase() ?? ''} ${user?.name?.split(" ")[1]?.charAt(0).toUpperCase() ?? ""}`}
                        </div>
                        <Button variant="ghost" className='pb-0' onClick={() => setOpenModal(true)}>
                            <Pencil />
                        </Button>
                    </div>
                )}
                <p className='text-gray-400 font-semibold !mb-1'>{user?.name}</p>
                <p className='text-gray-400 font-semibold !mb-1'>{user?.email}</p>
                <p className='text-gray-400 font-semibold flex items-center gap-3 !mb-1'>
                    {user?.phone}
                    <Button variant="ghost" className='!text-black' onClick={() => setOpenModal(true)}>
                        <Pencil />
                    </Button>
                </p>
            </div>
        </section>
        <section className='my-10'>
            <p className='text-[#FF8A00] !text-sm'>
                <Link to="/reset-password" className='!text-sm font-semibold pl-0 ml-0'>
                  Reset Password
                </Link>
            </p>
        </section>
        <EditProfileModal
            open={openModal}
            user={user}
            onCancel={() => setOpenModal(false)}
        />
    </div>
  )
}

export default General